import Vue from 'vue'
import VueCookies from 'vue-cookies'
import Storage from 'vue-ls';
import Search from '../components/Search.vue';
import Router from "../components/Router.vue";
import vco from "v-click-outside";

Vue.config.productionTip = false

Vue.use(VueCookies)
Vue.use(Storage, {
    namespace: 'igr_',
    name: 'ls',
    storage: 'local',
});
Vue.use(vco);

const router = Router;

new Vue({
    router,
    render: function (h) {
        return h(Search);
    },
    el: '#search',
    data: {
    },
    components: {
        Search
    },
    created() {
        this.$cookies.config('30d');
    },
    renderError (h, err) {
        return h('pre', { style: { color: 'red' }}, err.stack)
    }
});
